import { render } from "./Birth.vue?vue&type=template&id=2946f874&scoped=true"
import script from "./Birth.vue?vue&type=script&lang=js"
export * from "./Birth.vue?vue&type=script&lang=js"

import "./Birth.vue?vue&type=style&index=0&id=2946f874&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2946f874"]])

export default __exports__